import React from 'react';
import { Link } from 'react-router-dom';

import { Show } from '@bd-uikit-web/React/Utils';
import { Form, Input } from '@bd-uikit-web/React/Form';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

export default class ResetPassword extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      sending: false,
      done: false,
      link: false,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    if (bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('RESETPASSWORD');
      this.props.history.push('/');
      return;
    }

    window.location = `https://app.blackdove.com/reset-password/${this.props.token || this.props.match.params.token}`;
  }

  onFormSubmit(data) {
    if (data.passwordRepeat !== data.password) {
      rootDispatcher.dispatch('NB:OPEN', {
        type: 'error',
        msg: 'Your repeat password should match your password',
      });
      return;
    }
    const apiLink = `/forgot/token/${this.props.token || this.props.match.params.token}`;
    const apiData = data;

    this.setStateSending();
    bdReq
      .post(apiLink, apiData)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.setState({
          sending: false,
          done: true,
        });
      })
      .catch(() => {
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          msg: 'Invalid Token or Token Expired. Please reset the password again.',
        });
        this.setState({ link: true });
        return;
      });
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  render() {
    return (
      <div className="bg-image" style={{ backgroundImage: 'url(/assets/img/room.jpg)' }}>
        <SimpleModal open reset>
          <header className="modal__header text-center">
            <img className="header__logo" src="/assets/img/bd-logo-dark-text.svg" alt="Blackdove Logo" />
          </header>
          <div className="modal__body">
            <Show condition={this.state.done}>
              <h5 className="h--spacing-sm h--lower text-center">Password reset complete</h5>
              <div className="text-center">
                <small>
                  Your new password has now been set and you
                  <br />
                  can now login with these credentials on the login page or in the mobile app.
                </small>
              </div>
              <Link
                class="btn"
                style={{ width: '100%', marginTop: '15px' }}
                to={`/login?${this.props.location.search}`}
              >
                Go to login page
              </Link>
            </Show>

            <Show condition={!this.state.done}>
              <div className="text-center">
                <h5 className="h--spacing-sm h--lower h--medium-weight h4-5">
                  {this.props.type === 'set' ? 'Set Password' : 'Reset Password'}
                </h5>

                <p>
                  <small>
                    To make your password more secure, use a combination of upper and lower case letters, numbers and
                    special characters such as @, % and !.
                  </small>
                </p>

                <Form onSubmit={this.state.link ? this.props.history.push('/forgot-password') : this.onFormSubmit}>
                  <Input
                    type="password"
                    name="password"
                    placeholder="New Password"
                    invalidMsg="Please enter a new password"
                    disabled={this.state.link ? true : false}
                    required
                  />

                  <Input
                    type="password"
                    name="passwordRepeat"
                    placeholder="Confirm Password"
                    invalidMsg="Please repeat your password"
                    disabled={this.state.link ? true : false}
                    required
                  />

                  <div className="form__group">
                    {this.state.link ? (
                      <button className="btn--block" type="submit">
                        RESET PASSWORD
                      </button>
                    ) : (
                      <button className="btn--block" type="submit" disabled={this.state.sending}>
                        SET PASSWORD
                      </button>
                    )}
                  </div>
                </Form>

                <a className="a--clean" href="https://blackdove.zendesk.com/hc/en-us" target="_blank">
                  <small>
                    Still need help?{' '}
                    <strong className="strong--accent">
                      <u>Contact us</u>
                    </strong>
                  </small>
                </a>
              </div>
            </Show>
          </div>
        </SimpleModal>
      </div>
    );
  }
}
